"use strict";
exports.__esModule = true;
var resolve_url_1 = require("../helpers/resolve-url");
var url_helpers_1 = require("../helpers/url-helpers");
var validateURL = function (value, httpsRequired) {
    if (httpsRequired === void 0) { httpsRequired = false; }
    if (!value) {
        return '';
    }
    var URL = resolve_url_1["default"]();
    var parsedUrl;
    try {
        parsedUrl = new URL(value);
    }
    catch (err) {
        return 'Введён некорректный URL';
    }
    if (!url_helpers_1.containsProtocolDelimeter(value)) {
        return 'Введён некорректный URL';
    }
    if (!parsedUrl.protocol || !parsedUrl.hostname) {
        return 'Введён некорректный URL';
    }
    if (!url_helpers_1.isValidProtocol(parsedUrl.protocol, httpsRequired)) {
        return "\u0412 URL \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0441\u0445\u0435\u043C\u0430 " + (httpsRequired ? 'https' : 'http/https');
    }
    return '';
};
exports["default"] = validateURL;
